import { css } from 'styled-components'

export const breakpoints = {
    xsmall: 321,
    xsmallLegacy: 500,
    small: 769,
    medium: 992,
    large: 1281
}

export const media = {
    xsmall: (...args: any) => css`
        @media (min-width: 321px) {
            ${css(...args)};
        }
    `,
    small: (...args: any) => css`
        @media (min-width: 769px) {
            ${css(...args)};
        }
    `,
    medium: (...args: any) => css`
        @media (min-width: 992px) {
            ${css(...args)};
        }
    `,
    large: (...args: any) => css`
        @media (min-width: 1281px) {
            ${css(...args)};
        }
    `
}
